import { Button, Col, message, Row } from "antd";
import { FC, useCallback, useContext } from "react";
import { DrawRequestDocInterface, DrawRequestPreviewInterface, PaymentPreviewInterface } from "../../../../types/draw-request";
import { convertWithCommas, generateDownload } from "../../../../helpers";
import { DataContext } from "../../../../contexts/DataContext";
import { EyeFilled } from "@ant-design/icons";
import { drawRequestsService } from "../../../../services/draw-request";
import { ApproverResponse } from "../../../../types/approvers";

interface Props {
  drawRequestPreview?: DrawRequestPreviewInterface;
  paymentPreview?: PaymentPreviewInterface;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

/**========================================================================
 *                          external const here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

/**========================================================================
 *                           external methods here
 *========================================================================**/

/*============================ END OF SECTION ============================*/

export const DrawRequestPreview: FC<Props> = ({ drawRequestPreview, paymentPreview, setIsLoading }) => {
  /**========================================================================
   *                           Hooks here
   *========================================================================**/
  const {
    // projects,
    codes,
    drawRequestContext: {
      drawRequestData: { approvers: approversData, expatOfficers, paymentMethods }
    }
  } = useContext(DataContext);

  // useEffect(() => {
  //   console.log("payment preview here", { paymentPreview });
  // }, []);

  const getApprover = useCallback(
    (approver: ApproverResponse) => {
      const data = approversData.find((apr) => apr.id === approver.userID || apr.id === approver.id);
      if (!data) return "";
      return `${data.firstName} ${data.lastName} (${data.email})`;
    },
    [approversData]
  );

  const expOfficer = useCallback(() => {
    const data = expatOfficers.find((apr) => apr.id === paymentPreview?.expatOfficerId);
    if (!data) return "";
    return `${data.firstName} ${data.lastName} (${data.email})`;
  }, [approversData]);

  const expCharge = useCallback(() => {
    const data = expatOfficers.find((apr) => apr.id === paymentPreview?.expatInChargeId);
    if (!data) return "";
    return `${data.firstName} ${data.lastName} (${data.email})`;
  }, [approversData]);

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Const here
   *========================================================================**/

  /*============================ END OF SECTION ============================*/

  /**========================================================================
   *                           Methods here
   *========================================================================**/

  const getChargeTo = (value: string) => {
    switch (value) {
      case "capitalExpenditure":
        return "Capital Expenditure";
      case "tenantRelated":
        return "Tenant Related";
      case "generalAdministrative":
        return "General & Administrative";
      default:
        return "Tax & Financial";
    }
  };

  const viewDocByDRid = async (doc: DrawRequestDocInterface) => {
    setIsLoading(true);
    try {
      const resp = await drawRequestsService.getDocByDRid(doc.id);

      if (resp.status === 204) message.info("Document not found");
      else {
        const file = resp.data;

        const fileName = `${doc.name}-${doc.docType}-${new Date().toUTCString()}`;

        generateDownload(file, fileName, "pdf", true);

        // message.info("Document downloaded");
      }
    } catch (error) {
      console.error(error);
      message.error("Ups: something was wrong getting the documents, please try again later or contact the support");
    }
    setIsLoading(false);
  };

  /*============================ END OF SECTION ============================*/

  return (
    <>
      {/* /========================================================================  HTML here
    ========================================================================*/}
      {/* FORM 1 */}
      <Row style={{ width: "100%" }}>
        <Col xs={24} md={24} lg={9} style={{ padding: "10px" }}>
          <h3>Payment Request:</h3>
          <hr />
          <div className="review-column-container">
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Payment Method:
              </Col>
              <Col>{paymentMethods.find((pm) => pm.id === drawRequestPreview?.paymentMethod)?.name || ""}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Initiator:
              </Col>
              <Col>{drawRequestPreview?.initiator}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Project:
              </Col>
              <Col>{drawRequestPreview?.Project}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Draw No. / Invoice No.:
              </Col>
              <Col>{drawRequestPreview?.drawInvoice}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Amount:
              </Col>
              <Col>${convertWithCommas(drawRequestPreview?.amount)}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Due Date:
              </Col>
              <Col>{drawRequestPreview?.dueDate}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Invoice Date:
              </Col>
              <Col>{drawRequestPreview?.invoiceDate}</Col>
            </Row>

            {drawRequestPreview?.paymentMethod === 1 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    GL Code:
                  </Col>
                  <Col>
                    {codes.find((co) => co.id === drawRequestPreview?.glCode)?.account_name || ""} (
                    {codes.find((co) => co.id === drawRequestPreview?.glCode)?.gl_code || ""})
                  </Col>
                </Row>

                {/* <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    JV Deposit GL Code:
                  </Col>
                  <Col>
                    {codes.find((co) => co.id === drawRequestPreview?.jvDeposit)?.account_name || ""} (
                    {codes.find((co) => co.id === drawRequestPreview?.jvDeposit)?.gl_code || ""})
                  </Col>
                </Row>

                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    JV Withdrawal GL Code:
                  </Col>
                  <Col>
                    {codes.find((co) => co.id === drawRequestPreview?.jvWithdrawal)?.account_name || ""} (
                    {codes.find((co) => co.id === drawRequestPreview?.jvWithdrawal)?.gl_code || ""})
                  </Col>
                </Row> */}
              </>
            )}
            {drawRequestPreview?.controlNumber !== "0" && (
              <Row style={{ marginBottom: "10px" }}>
                <Col style={{ fontWeight: "bold" }} span={6}>
                  Control Number:
                </Col>
                <Col>{drawRequestPreview?.controlNumber}</Col>
              </Row>
            )}
          </div>
        </Col>

        {/* FORM 2 */}
        <Col xs={24} md={24} lg={15} style={{ padding: "10px" }}>
          <h3>Payment Form:</h3>
          <hr />
          <div className="review-column-container">
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Sanction No.:
              </Col>
              <Col>{paymentPreview?.sanctionNo}</Col>
            </Row>
            <Row>
              <Col style={{ fontWeight: "bold", marginBottom: 5 }}>Amount break Down:</Col>
            </Row>

            <Row style={{ paddingLeft: 20 }}>
              <Col style={{ fontWeight: "bold" }} xs={24} md={4}>
                Description
              </Col>
              <Col style={{ fontWeight: "bold" }} xs={24} md={4}>
                Amount
              </Col>
              <Col style={{ fontWeight: "bold" }} xs={24} md={4}>
                Sales Tax
              </Col>
              <Col style={{ fontWeight: "bold" }} xs={24} md={4}>
                Related Location
              </Col>
              {[3, 4, 5].includes(drawRequestPreview?.paymentMethod || 0) && (
                <Col style={{ fontWeight: "bold" }} xs={24} md={4}>
                  Gl Code
                </Col>
              )}
            </Row>
            <Row>
              <Col span={24}>
                <hr />
              </Col>
            </Row>
            {paymentPreview?.amountBreakdowns.map((abd, index) => {
              const code = codes.find((co) => co.id === abd.glCodeID);
              return (
                <>
                  <Row style={{ marginTop: "5px", paddingLeft: 20 }} key={index}>
                    <Col xs={24} md={4}>
                      {abd.name}
                    </Col>
                    <Col xs={24} md={4}>
                      ${convertWithCommas(abd.amount)}
                    </Col>
                    <Col xs={24} md={4}>
                      ${convertWithCommas(abd.saleTax)}
                    </Col>
                    <Col xs={24} md={4}>
                      {abd.relatedLocation}
                    </Col>
                    {[3, 4, 5].includes(drawRequestPreview?.paymentMethod || 0) && (
                      <Col span={6}>
                        {code && (
                          <div>
                            {code.account_name} ({code.gl_code})
                          </div>
                        )}
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col span={24}>
                      <hr />
                    </Col>
                  </Row>
                </>
              );
            })}

            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Payee:
              </Col>
              <Col>{paymentPreview?.payee}</Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Vendor Code:
              </Col>
              <Col>{paymentPreview?.vendorCode}</Col>
            </Row>
            {`${drawRequestPreview?.paymentMethod}` === "4" && (
              <Row style={{ marginBottom: "10px" }}>
                <Col style={{ fontWeight: "bold" }} span={6}>
                  Check Special Instructions:
                </Col>
                <Col>{paymentPreview?.checkSpecialInstructions}</Col>
              </Row>
            )}
            {/* <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Related Location:
              </Col>
              <Col>{paymentPreview?.relatedLocation}</Col>
            </Row> */}
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Address:
              </Col>
              <Col>
                {paymentPreview?.address} {paymentPreview?.address2}
              </Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Charge to:
              </Col>
              <Col span={18}>
                <Row>
                  <Col span={12}>{getChargeTo(paymentPreview?.chargeTo || "")}</Col>
                  <Col span={12}>{paymentPreview?.specify}</Col>
                </Row>
              </Col>
            </Row>

            {drawRequestPreview?.paymentMethod !== 4 && drawRequestPreview?.paymentMethod !== 5 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    {`Bank Name`}
                  </Col>
                  <Col>{paymentPreview?.bankName}</Col>
                </Row>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    {`${(drawRequestPreview?.paymentMethod || 4) === 2 ? "SWIFT" : "Bank ABA"}`}
                  </Col>
                  <Col>{paymentPreview?.abbaOrSwiftAccountNo}</Col>
                </Row>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    Account No.:
                  </Col>
                  <Col>{paymentPreview?.accountNo}</Col>
                </Row>
              </>
            )}
            {drawRequestPreview?.paymentMethod === 5 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    {`Debit Block ID`}
                  </Col>
                  <Col>{paymentPreview?.debitBlockID}</Col>
                </Row>
              </>
            )}
            {(drawRequestPreview?.amount || 0) >= 10000 && (
              <Row style={{ marginBottom: "10px" }}>
                <Col style={{ fontWeight: "bold" }} span={6}>
                  Agreement Path:
                </Col>
                <Col>{paymentPreview?.agreementPath}</Col>
              </Row>
            )}

            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Approvers:
              </Col>
              <Col span={15}>
                {paymentPreview?.approvers.map((ap) => (
                  <Row key={ap.id}>
                    <Col span={24}>{getApprover(ap)}</Col>
                  </Row>
                ))}
              </Col>
            </Row>
            <Row style={{ marginBottom: "10px" }}>
              <Col style={{ fontWeight: "bold" }} span={6}>
                Reviewers:
              </Col>
              <Col span={15}>
                {paymentPreview?.reviewers?.map((ap) => (
                  <Row key={ap.id}>
                    <Col span={24}>{getApprover(ap)}</Col>
                  </Row>
                ))}
              </Col>
            </Row>
            {(drawRequestPreview?.amount || 0) >= 10000 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    Expat in Charge:
                  </Col>
                  <Col>{expCharge()}</Col>
                </Row>
                <Row style={{ marginBottom: "10px" }}>
                  <Col style={{ fontWeight: "bold" }} span={6}>
                    Expat Officer:
                  </Col>
                  <Col>{expOfficer()}</Col>
                </Row>
              </>
            )}

            {paymentPreview?.documents?.length !== 0 && (
              <>
                <Row style={{ fontWeight: "bold" }}>Documents:</Row>
                {paymentPreview?.documents?.map((doc) => (
                  <div key={doc.id}>
                    <Row style={{ marginBottom: "10px" }}>
                      <Col style={{ fontWeight: "bold" }} span={6}>
                        {doc.docType}
                      </Col>
                      <Col>
                        <Row>
                          <div style={{ marginRight: 10 }}>{doc.name}</div>
                          <Button
                            // disabled={drawRequestState?.isDraft}
                            type="primary"
                            onClick={() => {
                              viewDocByDRid(doc);
                            }}
                            icon={<EyeFilled />}
                          >
                            view
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            )}
          </div>
        </Col>
      </Row>

      {/*============================ END OF SECTION ============================*/}
    </>
  );
};
